import { getClientsRequest, getCustomerRequest, getBackendVersionRequest, postSupportMessageRequest } from "@common";
import { FETCH_STATE_INITIAL } from "rd-redux-http";

export interface ClientInterface {
    clientId: string;
    name: string;
}

export interface ClientsInterface {
    clients: ClientInterface[];
}

export interface NotificationInterface {
    isOpen: boolean;
    message: string;
    isWarning?: boolean;
}

export interface PagesState {
    clients: typeof getClientsRequest.types.reduxState;
    customer: typeof getCustomerRequest.types.reduxState;
    notification: NotificationInterface;
    dashboardLink: string;
    backendVersion: typeof getBackendVersionRequest.types.reduxState;
    supportMessage: typeof postSupportMessageRequest.types.reduxState;
}

export const initialPagesState: PagesState = {
    clients: { fetchState: FETCH_STATE_INITIAL },
    customer: { fetchState: FETCH_STATE_INITIAL },
    notification: {
        isOpen: false,
        message: ""
    },
    dashboardLink: undefined,
    backendVersion: { fetchState: FETCH_STATE_INITIAL },
    supportMessage: { fetchState: FETCH_STATE_INITIAL }
};
